import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./18n";
import { SocketProvider } from "./SocketContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
const isLocalhost = window.location.hostname === "localhost";
const tg = window.Telegram.WebApp;
const Index = () => {
  const [tgId, setTgId] = useState();
  const [firstName, setFirstName] = useState(null);
  const [tgUsername, setTgUsername] = useState(null);
  const changePlayer = (tgId, firstName) => {
    setTgId(tgId);
    setFirstName(firstName);
  };

  useEffect(() => {
    const fetchTgInfo = async () => {
      try {
        if (tg.initDataUnsafe?.user) {
          setTgId(tg.initDataUnsafe.user.id);
          setTgUsername(tg.initDataUnsafe.user.username);
          setFirstName(tg.initDataUnsafe.user.first_name);
          tg.expand();
          tg.ready();
        } else {
          console.warn("Telegram user data not available. Using fallback.");
        }
      } catch (error) {
        console.error("Error during initialization:", error);
      }
    };

    fetchTgInfo();
  }, []);

  return (
    <SocketProvider tgId={tgId}>
      {tgId && (
        <App tgId={tgId} firstName={firstName} tgUsername={tgUsername}></App>
      )}

      {isLocalhost && !tgId && (
        <div style={{ zIndex: 20 }}>
          <button
            className="button-spin"
            onClick={() => {
              changePlayer(1, "PC 01");
            }}
          >
            PLAYER 1
          </button>
          <button
            className="button-spin"
            onClick={() => {
              changePlayer(542736222, "PC 02");
            }}
          >
            PLAYER 2
          </button>
        </div>
      )}
    </SocketProvider>
  );
};

root.render(<Index />);
